// @flow

import type {
  Action,
} from 'fc-flow-types/redux'

// Action Types
import {
  FETCH_SOIL_JOBS,
  FILTER_BY_ASSIGN_TO,
  FILTER_BY_STATUS,
  FILTER_BY_DATE_RANGE,
  FILTER_BY_SEASON,
  IMPORT_JOBS,
} from './constants'

export const fetchSoilJobs = function (): Action<void> {
  return {
    type: FETCH_SOIL_JOBS,
  }
}

export const filterJobsByAssignedTo = function (userId: string): Action<void> {
  return {
    type: FILTER_BY_ASSIGN_TO,
    payload: userId,
  }
}

export const filterJobsByStatus = function (status: string): Action<void> {
  return {
    type: FILTER_BY_STATUS,
    payload: status,
  }
}

export const filterJobsByDateRange = function ({startDate, endDate}: Object): Action<void> {
  return {
    type: FILTER_BY_DATE_RANGE,
    payload: { startDate, endDate },
  }
}

export const filterJobsBySeason = function (payload: number): Action<void> {
  return {
    type: FILTER_BY_SEASON,
    payload,
  }
}

export const importJobs = function (payload: Object): Action<void> {
  return {
    type: IMPORT_JOBS,
    payload,
  }
}
